<template>
  <div class="paymenberApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <ul>
      <li v-for="(item,i) in arr" @click="toPush(item.id,'mdetail?oid='+id)">
        <div class="left">
          <span><i>￥</i>{{item.rate}}</span>
          <span>{{item.status == 1 ? '周卡' : item.status == 2 ? '月卡' : item.status == 3?'季度卡':item.status == 4?'年卡':'日卡'}}</span>
        </div>
        <div class="right">
          <h2>{{item.title}}</h2>
          <p>{{item.briefly}}</p>
          <p>返现金额：{{item.rebate}}元</p>
        </div>
        <a>抢购</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        arr:[],
        positionFlag:false,
        id:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      this.id = this.$route.query.id
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/menber'
        }).then(function(response){
          var res = response.data;
          that.arr = res.data
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .paymenberApp{
    background:#ececec;
  }
  .paymenberApp ul{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .paymenberApp ul li{
    background:#fff;
    width:100%;
    margin-bottom:15px;
    position:relative;
    border-radius:6px;
    padding:15px 0
  }
  .paymenberApp ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .paymenberApp ul li .left{
    float:left;
    width:22%;
  }
  .paymenberApp ul li .left span{
    display:block;
    background:#fbe0a8;
    border-radius:5px;
    width:83%;
    text-align:center;
    color:#825329;
    font-size:12px;
    margin-left:auto;
  }
  .paymenberApp ul li .left span:first-child{
    height:45px;
    line-height:45px;
    font-size:17px;
    font-weight:bold
  }
  .paymenberApp ul li .left span:last-child{
    height:25px;
    line-height:25px;
    position:relative;
  }
  .paymenberApp ul li .left span:last-child:after{
    content:'';
    position:absolute;
    border-top:#e7ce98 dashed 1px;
    width:88%;
    height:1px;
    left:50%;
    transform: translateX(-50%);
    top:-1px
  }
  .paymenberApp ul li .left span i{
    font-size:12px;
    font-weight:400
  }
  .paymenberApp ul li .right{
    float:left;
    width:70%;
    margin-left:3%
  }
  .paymenberApp ul li .right h2{
    font-size:15px;
  }
  .paymenberApp ul li .right p{
    font-size:13px;
    color:#666;
    padding-top:8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width:70%
  }
  .paymenberApp  ul li a{
    position:absolute;
    right:4%;
    bottom:20px;
    color:#fff;
    background:#f00;
    border-radius: 30px;
    width: 63px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
</style>